<template>
  <header id="header">
    <div class="header-container">
      <div class="logo"></div>
      <div class="language-list">
        <!-- <div class="list-open" @click="showLanguageList()">
          <span class="text">{{ $t('language') }}</span>
          <span class="icon-dropdown"></span>
        </div>  
        <div class="list">
          <div class="item" v-for="(lang, idx) in languages" :key="idx" @click="setLanguage(lang)">
            <span class="flag" :style="{ backgroundImage: `url(./${lang.flag}.svg)`}"></span>
            <span class="text">{{ lang.text }}</span>
          </div>
        </div>     -->
      </div>
    </div>

    <LanguageList></LanguageList>
  </header>
</template>

<script>
import vuex from 'vuex'

import LanguageList from './modals/LanguageList.vue'

export default {
  components: {
    LanguageList
  },
  data () {
    return {
      // isLanguageList: false,
      // languages: [
      //   { locale: 'en',  text: 'English', flag: 'united-states' },
      //   { locale: 'ko',  text: '한국어', flag: 'south-korea' },
      //   { locale: 'jp',  text: '日本語', flag: 'japan' },
      // ]
    }
  },
  created () {
  },
  methods: {
    ...vuex.mapActions({
      'TOGGLE_LANGUAGE_LIST': 'request/TOGGLE_LANGUAGE_LIST',
      'SET_LANGUAGE': 'request/SET_LANGUAGE'
    }),
    showLanguageList () {
      this.TOGGLE_LANGUAGE_LIST(true)
    },
    setDefaultLanguage () {
      let locale = this.$route.query.locale;
      console.log(locale)
      if (locale) {
        this.setLanguage({ locale })
      }
    },
    async setLanguage (language) {
      await this.SET_LANGUAGE(language.locale);
      this.$i18n.locale = language.locale; 
    },
  },
}
</script>

<style lang="scss">
#header {
  height: 44px;

  background-color: $black;
  color: $white;

  .header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    max-width: 768px;
    margin: 0 auto;

    .logo {
      flex-grow: 165px;
      height: 44px;
      width: 165px;

      background-image: url("../images/logo.svg");
    }

    .language-list {
      
    }

    .list-open {
      padding-right: 22px;

      font-size: 17px;
      line-height: 44px;

      text-align: right;

      @media all and (min-width: 768px) {
        display: none;
      }

      .text {
        font-weight: bold;
      }

      .icon-dropdown {
        display: inline-block;
        width: 22px;
        height: 44px;

        background-image: url("../images/dropdown-nor.svg");
        background-size: 22px;
        background-position: center;
        background-repeat: no-repeat;

        vertical-align: middle;
      }
    }
    
    .list {
      display: flex;
      flex-direction: row;

      .item {
        display: block;
        margin: 0 15px;

        line-height: 44px;        

        .flag {
          display: inline-block;
          width: 30px;
          height: 30px;

          background-image: url('../images/united-states.svg');
          background-position: center;
          background-size: 30px;
          background-repeat: no-repeat;

          vertical-align: middle;
        }

        .text {
          display: inline-block;
          height: 44px;
          margin-left: 10px;

          vertical-align: middle;
        }
      }

      @media all and (max-width: 768px) {
        display: none;
      }
    }
  }


}
</style>